export const initialSpinnerState = {
  loading: false,
  message: '',
};

// eslint-disable-next-line default-param-last
export const spinner = (state = initialSpinnerState, { type, payload = {} }) => {
  if (type === 'SPINNER_SHOWN') {
    return {
      ...state,
      loading: true,
      message: initialSpinnerState.message,
      ...payload,
    };
  }
  if (type === 'SPINNER_HIDDEN') {
    return {
      ...state,
      loading: false,
      ...payload,
    };
  }
  if (type === 'SPINNER_TOGGLED') {
    return {
      ...state,
      loading: !state.loading,
      ...payload,
    };
  }
  return state;
};
